/**
 * @module app.core
 */

import { valueConverter } from 'aurelia-framework';
import { ICustomFieldChoice, ICustomFieldDefinition, ICustomFieldDefinitionContainer, ICustomFieldDefinitionsTextCollectionIndexer, ICustomFieldDefinitionsLookupCollectionIndexer } from '../interfaces';

@valueConverter('customFieldDefinition')
export default class CustomFieldDefinitionValueConverter {

    public toView(definition: ICustomFieldDefinition, container: ICustomFieldDefinitionContainer | null, mode: 'text' | 'id' | 'code' | 'model' = 'text'): ICustomFieldChoice | string | null {
        if(!container) { return null };

        if(definition.property && definition.property.type && definition.property.field) {
            if(definition.property.type === 'text' && container.text) {
                const texts = (container.text || null) as ICustomFieldDefinitionsTextCollectionIndexer | null;
                if(texts) {
                    return texts[definition.property.field] || null;
                }
            }
            else if(definition.property.type === 'lookup' && container.lookup) {
                const lookups = (container.lookup || null) as ICustomFieldDefinitionsLookupCollectionIndexer | null;
                if(lookups) {
                    const lookup = lookups[definition.property.field] || null;
                    if(lookup) {
                        if(mode === 'text') {
                            return lookup.description || null;
                        }
                        else if(mode === 'id') {
                            return lookup.id || null;
                        }
                        else if(mode === 'code') {
                            return lookup.code || null;
                        }
                        else {
                            return lookup;
                        }
                    }
                }
            }
        }

        return null;
    }

}
